export default __webpack_public_path__ + "static/media/cheers.14b8c18b.webp";